import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { apiError } from "../lib/auth";
import { PageHeader, NeonButton } from "../components/common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { STAGE_LABEL } from "../components/enterprise/EnterpriseNav";
import { Overview, Vetting, DealTerms } from "../components/enterprise/Overview";
import { Branding, Clients, Ledger, Report, Playbook } from "../components/enterprise/Sections";
import { PitchStudio } from "../components/enterprise/pitch/PitchStudio";

const TABS = [["overview", "Overview"], ["vetting", "Vetting"], ["terms", "Terms"], ["branding", "Branding"], ["clients", "Clients"], ["ledger", "Ledger"], ["report", "ROI & billing"], ["pitch", "Pitch studio"], ["playbook", "Playbook"]];

export default function PartnerDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [p, setP] = useState(null);
  const [meta, setMeta] = useState(null);
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    api.get(`/enterprise/partners/${id}`).then((r) => setP(r.data)).catch(() => setDenied(true));
    api.get("/enterprise/partners").then((r) => setMeta(r.data)).catch(() => {});
  }, [id]);
  const remove = async () => {
    if (!window.confirm(`Delete ${p.name}? This can't be undone.`)) return;
    try { await api.delete(`/enterprise/partners/${p.id}`); toast.success("Partner deleted"); nav("/app/enterprise"); } catch (e) { toast.error(apiError(e)); }
  };
  if (denied) return <p className="text-white/50" data-testid="partner-detail-denied">Page not found.</p>;
  if (!p || !meta) return <p className="font-mono text-xs text-white/40">loading…</p>;
  return (
    <div data-testid="partner-detail-page">
      <Link to="/app/enterprise" className="inline-flex items-center gap-1 text-xs text-white/50 hover:text-brand mb-3" data-testid="partner-back"><ArrowLeft className="w-3 h-3" /> All partners</Link>
      <PageHeader eyebrow={`// ${STAGE_LABEL[p.stage]} · ${p.model.replace("_", "-")} · score ${p.score}/100`} title={p.name}>
        <NeonButton variant="danger" onClick={remove} data-testid="partner-delete"><Trash2 className="w-3 h-3" /> Delete</NeonButton>
      </PageHeader>
      <Tabs defaultValue="overview">
        <TabsList className="flex flex-wrap h-auto mb-6">{TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`partner-tab-${k}`}>{l}</TabsTrigger>)}</TabsList>
        <TabsContent value="overview"><Overview p={p} setP={setP} stages={meta.stages} /></TabsContent>
        <TabsContent value="vetting"><Vetting p={p} setP={setP} criteria={meta.criteria} /></TabsContent>
        <TabsContent value="terms"><DealTerms p={p} setP={setP} /></TabsContent>
        <TabsContent value="branding"><Branding p={p} setP={setP} /></TabsContent>
        <TabsContent value="clients"><Clients p={p} setP={setP} /></TabsContent>
        <TabsContent value="ledger"><Ledger p={p} /></TabsContent>
        <TabsContent value="report"><Report p={p} /></TabsContent>
        <TabsContent value="pitch"><PitchStudio p={p} /></TabsContent>
        <TabsContent value="playbook"><Playbook p={p} setP={setP} /></TabsContent>
      </Tabs>
    </div>
  );
}
